import * as NetworkService from "./networkService";

export function getCountries() {
  return new Promise((resolve, reject) => {
    NetworkService.get(process.env.API_URL + "/country-codes/", undefined)
      .then((countries) => {
        resolve(countries.data.results);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function createOtpRequest(countryCode, phoneNumber) {
  return new Promise((resolve, reject) => {
    NetworkService.post(
      `${process.env.API_URL}/auth/login/otp/`,
      {
        APPLICATIONCONTEXT: "teacher"
      },
      {
        phone_number: {
          number: phoneNumber,
          country_code: countryCode
        }
      }
    )
      .then((result) => {
        resolve(result.data);
      })
      .catch((error) => {
        reject(error.response || error.message);
      });
  });
}

export function verifyOtpRequest(phoneNumberId, otpCode) {
  return new Promise((resolve, reject) => {
    NetworkService.post(
      `${process.env.API_URL}/auth/login/otp/verify/`,
      {
        APPLICATIONCONTEXT: "teacher"
      },
      {
        phone_number: phoneNumberId,
        otp: otpCode
      }
    )
      .then((result) => {
        resolve(result.data);
      })
      .catch((error) => {
        reject(error.response || error.message);
      });
  });
}

export function getCities() {
  return new Promise((resolve, reject) => {
    NetworkService.get(`${process.env.API_URL}/cities/`, {})
      .then((result) => {
        resolve(result.data);
      })
      .catch((error) => {
        reject(error.response || error.message);
      });
  });
}

export function getTeacherActivitySummary() {
  return new Promise((resolve, reject) => {
    NetworkService.get(
      `${process.env.API_URL}/visio/teachers/activity-summary/`
    )
      .then((result) => {
        resolve(result.data);
      })
      .catch((error) => {
        reject(error.response || error.message);
      });
  });
}

export function getMe() {
  return new Promise((resolve, reject) => {
    NetworkService.get(`${process.env.API_URL}/v2/teachers/me/`)
      .then((result) => {
        resolve(result.data);
      })
      .catch((error) => {
        reject(error.response || error.message);
      });
  });
}

export function getVisioReportTypes() {
  return new Promise((resolve, reject) => {
    NetworkService.get(`${process.env.API_URL}/question-report-types/`)
      .then((result) => {
        resolve(result.data);
      })
      .catch((error) => {
        reject(error.response || error.message);
      });
  });
}

export function getVisioQuestion() {
  return new Promise((resolve, reject) => {
    NetworkService.get(`${process.env.API_URL}/visio/similar-questions/`)
      .then((result) => {
        // for debug
        //resolve({"id":31,"rate":0.8748157967893321,"status":"pending","question":{"id":1046,"media":{"small":"https://dev-kunduz-tr.s3.eu-central-1.amazonaws.com/media/small/2-2019-09-20_1505110000-v6PE.jpg","original":"https://dev-kunduz-tr.s3.eu-central-1.amazonaws.com/media/optimized/2-2019-09-20_1505110000-v6PE.jpg","rotated":"https://dev-kunduz-tr.s3.eu-central-1.amazonaws.com/media/media/2-2019-09-20_1505110000-v6PE.jpg"},"created":"2019-09-20T18:05:13.224482+03:00","course":"Matematik","ocr":{"text":"Bir oyuncakçinın belirli bir günde sattiğı oyuncakların\nsavisı 12 den çok, 20 den azdır. Bu oyuncakçı x tane\noyuncağı her oyuncaktan 8 TL kar, y tane oyuncaği\nda her oyuncaktan 3 TL zarar ederek satmiş ve bu\nsatştan 48 TL den çok kår etmiştir.\nBuna göre, (x, y) ikililerinin analitik düzlemde bu-\nlunduğu bölge aşağidakilerden hangisinde taralı\nolarak gösterilmiştir?\n123420\n8x-3y 48\ny20\nx y 12\ny 12\n91-\n8x-3y 24\nx y 12\ny 10\nxy 12\n8x-3y 24","rotation_angle":-89.25712379946606}},"similar_question":{"id":1021,"media":{"small":"https://dev-kunduz-tr.s3.eu-central-1.amazonaws.com/media/small/2-2019-08-01_0213190000-hBs6.jpg","original":"https://dev-kunduz-tr.s3.eu-central-1.amazonaws.com/media/optimized/2-2019-08-01_0213190000-hBs6.jpg","rotated":"https://dev-kunduz-tr.s3.eu-central-1.amazonaws.com/media/media/2-2019-08-01_0213190000-hBs6.jpg"},"created":"2019-08-01T05:13:22.047101+03:00","course":"Matematik","ocr":{"text":"Bir oyuncakçınin belirli bir günde sattığı oyuncakların\nsavisı 12 den çok, 20 den azdır. Bu oyuncakçı x tane\noyuncağı her oyuncaktan 8 TL kâr, y tane oyuncaği\nda her oyuncaktan 3 TL zarar ederek satmış ve bu\nsatıştan 48 TL den çok kâr etmiştir\nBuna göre, (x, y) ikililerinin analitik düzlemde bu-\nlunduğu bölge aşağıdakilerden hangisinde taral\nolarak gösterilmiştir?\n123420\nB)\n8x-3y 48\n8x-3y 48\nx+y= 20\n+y 12\nx+y 20\nX+y 12\n-16\n-16\n8x-3y= 48\n8x-3y 24\nX+y 20\nX+y 12\ny= 12\n-16\nE)\n8x-3y 24","rotation_angle":0.0}}});

        resolve(result.data);
      })
      .catch((error) => {
        reject(error.response || error.message);
      });
  });
}

export function saveVisioQuestion(id, data) {
  return new Promise((resolve, reject) => {
    NetworkService.put(
      `${process.env.API_URL}/visio/similar-questions/${id}/`,
      null,
      data
    )
      .then((result) => {
        resolve(result.data);
      })
      .catch((error) => {
        reject(error.response || error.message);
      });
  });
}

export function getVisioAnswer() {
  return new Promise((resolve, reject) => {
    NetworkService.get(`${process.env.API_URL}/visio/answers/`)
      .then((result) => {
        /*resolve({
          id: 2,
          question: {
            id: 982,
            media: {
              original: "https://dev-kunduz-tr.s3.eu-central-1.amazonaws.com/media/media/131-2019-07-25_0123170000-F7Js.jpg"
            },
            image:
              "https://dev-kunduz-tr.s3.eu-central-1.amazonaws.com/media/media/131-2019-07-25_0123170000-F7Js.jpg",
            created: "2019-07-25T04:23:20.469638+03:00",
            google_ocr: null
          },
          answer: {
            id: 358,
            media: {
              original: "https://dev-kunduz-tr.s3.eu-central-1.amazonaws.com/media/media/131-2019-07-25_0123170000-F7Js.jpg"
            },
            image:
              "https://dev-kunduz-tr.s3.eu-central-1.amazonaws.com/media/media/5-2019-06-27_0009570000-2EsC.jpg",
            answer_time: "2019-06-27T03:10:03.580888+03:00",
            feedback_rate: null,
            feedback_comment: null,
            subject: null,
            choice: null,
            quality_rate: null,
            difficulty_rate: null
          }
        });*/
        resolve(result.data);
      })
      .catch((error) => {
        reject(error.response || error.message);
      });
  });
}

export function saveVisioAnswer(id, data) {
  return new Promise((resolve, reject) => {
    NetworkService.put(`${process.env.API_URL}/visio/answers/${id}/`, null, {
      quality_tags: data
    })
      .then((result) => {
        resolve(result.data);
      })
      .catch((error) => {
        reject(error.response || error.message);
      });
  });
}

export function getVisioQualityTags() {
  return new Promise((resolve, reject) => {
    NetworkService.get(`${process.env.API_URL}/visio/quality-tags/`)
      .then((result) => {
        resolve(result.data);
      })
      .catch((error) => {
        reject(error.response || error.message);
      });
  });
}

export function reportVisioQuestion(id, data) {
  return new Promise((resolve, reject) => {
    NetworkService.post(
      `${process.env.API_URL}/visio/questions/${id}/report/`,
      null,
      { reason: data }
    )
      .then((result) => {
        resolve(result.data);
      })
      .catch((error) => {
        reject(error.response || error.message);
      });
  });
}

/*
export function getVisioQuestion() {
  return new Promise((resolve, reject) => {
    NetworkService.get(`${process.env.API_URL}/visio/questions/`)
      .then((result) => {
        resolve(result.data);
      })
      .catch((error) => {
        reject(error.response || error.message);
      });
  });
}

export function rejectVisioQuestion(questionId) {
  return new Promise((resolve, reject) => {
    NetworkService.put(
      `${process.env.API_URL}/visio/questions/${questionId}/`,
      null,
      {
        status: "rejected"
      }
    )
      .then((result) => {
        resolve(result.data);
      })
      .catch((error) => {
        reject(error.response || error.message);
      });
  });
}

export function reportVisioQuestion(questionId, reason) {
  return new Promise((resolve, reject) => {
    NetworkService.put(
      `${process.env.API_URL}/visio/questions/${questionId}/`,
      null,
      {
        status: "reported",
        reason
      }
    )
      .then((result) => {
        resolve(result.data);
      })
      .catch((error) => {
        reject(error.response || error.message);
      });
  });
}

export function matchVisioQuestion(questionId, similarQuestionId) {
  return new Promise((resolve, reject) => {
    NetworkService.put(
      `${
        process.env.API_URL
      }/visio/similar-question-rates/${similarQuestionId}/`,
      null,
      {
        status: "matched"
      }
    )
      .then((result) => {
        resolve(result.data);
      })
      .catch((error) => {
        reject(error.response || error.message);
      });
  });
}

export function matchVisioQuestionButNotSend(questionId, similarQuestionId) {
  return new Promise((resolve, reject) => {
    NetworkService.put(
      `${
        process.env.API_URL
      }/visio/similar-question-rates/${similarQuestionId}/`,
      null,
      {
        status: "matched_but_not_send"
      }
    )
      .then((result) => {
        resolve(result.data);
      })
      .catch((error) => {
        reject(error.response || error.message);
      });
  });
}

export function getVisioPending(){
  return new Promise((resolve, reject) => {
    NetworkService.get(`${process.env.API_URL}/visio/dashboard/`)
      .then((result) => {
        resolve(result.data);
      })
      .catch((error) => {
        reject(error.response || error.message);
      });
  });
}
*/

export function changeTeacherAvailability(teacherId, availability) {
  return new Promise((resolve, reject) => {
    NetworkService.patch(
      `${process.env.API_URL}/v2/teachers/${teacherId}/`,
      {
        APPLICATIONCONTEXT: "teacher"
      },
      {
        is_available: availability
      }
    )
      .then((result) => {
        resolve(result.data);
      })
      .catch((error) => {
        reject(error.response || error.message);
      });
  });
}

export function getVisioActivitySummary() {
  return new Promise((resolve, reject) => {
    NetworkService.get(
      `${process.env.API_URL}/visio/teachers/activity-summary/`
    )
      .then((result) => {
        resolve(result.data);
      })
      .catch((error) => {
        reject(error.response || error.message);
      });
  });
}
